import Reflux from 'reflux';
import ToastActions from 'flux/actions/ToastActions';
import BaseMixin from 'flux/stores/BaseMixin';
import { OrderedMap } from 'immutable';

/**
 * ToastStore
 *
 * Handles toast messages (See http://developer.android.com/guide/topics/ui/notifiers/toasts.html)
 *
 */
export default Reflux.createStore({
  listenables: [ToastActions],

  mixins: [BaseMixin],

  init() {
    this.setState(OrderedMap());
  },

  onSuccess(content) {
    this._toast(content, 'success');
  },

  onFailure(content, timeout) {
    this._toast(content, 'failure', timeout);
  },

  _toast(content, type, timeout) {
    const delay = timeout || 2000;
    let id = new Date().getTime();

    this.setStateAndTrigger(this.getState().set(id, { content, type }));

    setTimeout(
      () => this.setStateAndTrigger(this.getState().delete(id)),
      delay,
    );
  },

  onSaved() {
    ToastActions.success('Saved.');
  },

  onCopied(content) {
    this._toast(content, 'copied');
  },
});
